// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__fo96N","mainHeader":"Header_mainHeader__Ic9kO","imgContainer":"Header_imgContainer__qLWhO","img":"Header_img__+PdLZ"};